/*!
  =========================================================
  * Muse Ant Design Dashboard - v1.0.0 (Customized Glassmorphism)
  =========================================================
  * Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
  * Licensed under MIT
  * Enhanced by Aletheia Run Glass Theme
  =========================================================
*/

import { useState, useEffect } from "react";
import {
  Row,
  Col,
  Typography,
  Modal,
  message,
  Button,
} from "antd";
import {
  ExclamationCircleOutlined,
  CommentOutlined,
  SunOutlined,
  MoonOutlined,
} from "@ant-design/icons";

import moment from "moment";
import { PD_SOCKET_URI } from "./../../services";

const { confirm } = Modal;
const { Text } = Typography;

const profile = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
      fill="#fff"
    ></path>
  </svg>,
];

const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path
      fill="#fff"
      d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
    ></path>
  </svg>,
];

function Header({ name, onPress }) {
  const AuthUser = JSON.parse(localStorage.getItem("auth_data"));
  // inside Header component
const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");

// Load CSS dynamically based on theme
useEffect(() => {
  const linkId = "glass-theme-link";
  let existingLink = document.getElementById(linkId);

  if (theme === "dark") {
    if (!existingLink) {
      const link = document.createElement("link");
      link.id = linkId;
      link.rel = "stylesheet";
      link.href = "/assets/styles/glass-theme.css";
      document.head.appendChild(link);
    }
  } else {
    if (existingLink) {
      existingLink.remove();
    }
  }

  localStorage.setItem("theme", theme);
}, [theme]);

  // 🚪 Logout confirmation
  const thisLogOut = () => {
    confirm({
      title: "Do you want to Logout?",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        window.localStorage.clear();
        window.location.reload();
      },
    });
  };




  return (
    <Row gutter={[24, 0]} align="middle" justify="space-between">
      {/* <Col span={12}>
        <div className="ant-page-header-heading">
          <span
            className="ant-page-header-heading-title"
            style={{
              textTransform: "capitalize",
              color: "#fff",
              fontWeight: 500,
              textShadow: "0 0 8px rgba(255,255,255,0.3)",
            }}
          >
            {name || "Dashboard"}
          </span>
        </div>
      </Col> */}

      <Col span={24} className="header-control" style={{ textAlign: "right" }}>
        <Button
          type="link"
          className="sidebar-toggler"
          onClick={() => onPress()}
          style={{ marginRight: "8px" }}
        >
          {toggler}
        </Button>

        <Text
          strong
          style={{
            marginRight: "12px",
            color: "#000",
            textShadow: "0 0 6px rgba(255,255,255,0.3)",
          }}
        >
          Hi, {AuthUser?.email || "User"}
        </Text>

        {/* 🌗 Theme Toggle Orb */}
        {/* <button
          className="theme-toggle-btn"
          onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
          style={{ marginRight: "12px" }}
        >
          {theme === "dark" ? <SunOutlined /> : <MoonOutlined />}
        </button> */}

        <a onClick={thisLogOut} className="btn-sign-in" style={{ color: "#000" }}>
          {profile}
          <span style={{ marginLeft: "6px" }}>Log Out</span>
        </a>
      </Col>
    </Row>
  );
}

export default Header;
